import { render, staticRenderFns } from "./FormOverview.vue?vue&type=template&id=1582a53f&"
import script from "./FormOverview.vue?vue&type=script&lang=js&"
export * from "./FormOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports